import { useTranslation } from "../../core/translation.core";

export function OrderStatus({ status }: { status: string; pickup: boolean }) {
  const { t, msg } = useTranslation();

  if (status === "completed") {
    return (
      <div className="bg-[#E9F8E9] text-[#21B822] w-fit h-fit px-4 py-2 flex justify-center items-center gap-2 font-semibold  rounded-md">
        <span>
          <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.0625 5.375L3.8125 8.375L7.9375 1.625"
              stroke="#21B822"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span>{t(msg.order.completed)}</span>
      </div>
    );
  }

  if (status === "partailPayment" || status === "pending") {
    return (
      <div className="bg-[#FFF6E4] text-[#F4A32A] w-fit h-fit px-4 py-2 flex items-center gap-2 font-semibold  rounded-md">
        <span>
          <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.5 1C1.5 1.13261 1.44732 1.25978 1.35355 1.35355C1.25979 1.44732 1.13261 1.5 1 1.5C0.867392 1.5 0.740215 1.44732 0.646447 1.35355C0.552678 1.25978 0.5 1.13261 0.5 1C0.5 0.867392 0.552678 0.740215 0.646447 0.646447C0.740215 0.552679 0.867392 0.5 1 0.5C1.13261 0.5 1.25979 0.552679 1.35355 0.646447C1.44732 0.740215 1.5 0.867392 1.5 1ZM5.5 1C5.5 1.13261 5.44732 1.25978 5.35355 1.35355C5.25979 1.44732 5.13261 1.5 5 1.5C4.86739 1.5 4.74022 1.44732 4.64645 1.35355C4.55268 1.25978 4.5 1.13261 4.5 1C4.5 0.867392 4.55268 0.740215 4.64645 0.646447C4.74022 0.552679 4.86739 0.5 5 0.5C5.13261 0.5 5.25979 0.552679 5.35355 0.646447C5.44732 0.740215 5.5 0.867392 5.5 1ZM9.5 1C9.5 1.13261 9.44732 1.25978 9.35355 1.35355C9.25979 1.44732 9.13261 1.5 9 1.5C8.86739 1.5 8.74021 1.44732 8.64645 1.35355C8.55268 1.25978 8.5 1.13261 8.5 1C8.5 0.867392 8.55268 0.740215 8.64645 0.646447C8.74021 0.552679 8.86739 0.5 9 0.5C9.13261 0.5 9.25979 0.552679 9.35355 0.646447C9.44732 0.740215 9.5 0.867392 9.5 1Z"
              fill="#F4A32A"
              stroke="#F4A32A"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span className="">{status === "pending" ? t(msg.order.pending) : t(msg.order.partailPayment)}</span>
      </div>
    );
  }

  if (status === "returned") {
    return (
      <div className="bg-[#EBF2FD] text-[#3478F7] w-fit h-fit px-4 py-2 flex justify-center items-center gap-2 font-semibold  rounded-md">
        <span>
          <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.5 1C1.5 1.13261 1.44732 1.25978 1.35355 1.35355C1.25979 1.44732 1.13261 1.5 1 1.5C0.867392 1.5 0.740215 1.44732 0.646447 1.35355C0.552678 1.25978 0.5 1.13261 0.5 1C0.5 0.867392 0.552678 0.740215 0.646447 0.646447C0.740215 0.552679 0.867392 0.5 1 0.5C1.13261 0.5 1.25979 0.552679 1.35355 0.646447C1.44732 0.740215 1.5 0.867392 1.5 1ZM5.5 1C5.5 1.13261 5.44732 1.25978 5.35355 1.35355C5.25979 1.44732 5.13261 1.5 5 1.5C4.86739 1.5 4.74022 1.44732 4.64645 1.35355C4.55268 1.25978 4.5 1.13261 4.5 1C4.5 0.867392 4.55268 0.740215 4.64645 0.646447C4.74022 0.552679 4.86739 0.5 5 0.5C5.13261 0.5 5.25979 0.552679 5.35355 0.646447C5.44732 0.740215 5.5 0.867392 5.5 1ZM9.5 1C9.5 1.13261 9.44732 1.25978 9.35355 1.35355C9.25979 1.44732 9.13261 1.5 9 1.5C8.86739 1.5 8.74021 1.44732 8.64645 1.35355C8.55268 1.25978 8.5 1.13261 8.5 1C8.5 0.867392 8.55268 0.740215 8.64645 0.646447C8.74021 0.552679 8.86739 0.5 9 0.5C9.13261 0.5 9.25979 0.552679 9.35355 0.646447C9.44732 0.740215 9.5 0.867392 9.5 1Z"
              fill="#3478F7"
              stroke="#3478F7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>

        <span>{t(msg.order.pendingPickup)}</span>
      </div>
    );
  }

  return (
    <div className="bg-[#FEE5E5] text-[#F20000] w-fit h-fit px-4 py-2 flex items-center gap-2 font-semibold  rounded-md">
      <span>
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9L9 3L3 9ZM3 3L9 9L3 3Z" fill="#F20000" />
          <path d="M3 9L9 3M3 3L9 9" stroke="#F20000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span>{t(msg.order.cancelled)}</span>
    </div>
  );
}
